import { isPlatformBrowser } from '@angular/common';

import { WindowService } from '../shared/services/window.service';

export function serviceWorkerApiAvailableFactory(
    windowService: WindowService,
    platformId: string
): boolean {
    // Service worker is only available within a Browser
    if (!isPlatformBrowser(platformId)) {
        return false;
    }

    // Use this block to feature detect browser APIs required to register or run the
    // service worker.
    try {
        const nativeWindow = windowService.nativeWindow;
        const navigator = nativeWindow.navigator;

        if (!('serviceWorker' in navigator)) {
            return false;
        }

        const { getRegistration, getRegistrations } = navigator.serviceWorker;

        const hasRegistrationApi = !!(getRegistration && getRegistrations);

        if (!hasRegistrationApi) {
            return false;
        }

        // The service worker makes use of the URL API.
        // This tests for the constructor.
        if (!('URL' in nativeWindow)) {
            return false;
        }

        // This tests for the `searchParams` property.
        // See browser support: https://developer.mozilla.org/en-US/docs/Web/API/URL/searchParams#Browser_compatibility
        return URL.prototype.hasOwnProperty('searchParams');
    } catch {
        // Any uncaught exception here will disallow the application
        // from registering a service worker
        return false;
    }
}
